import { TooltippedIcon } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { Checkbox, Body, Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey, DataTestId } from '@mews-commander/enums';
import { IconName } from '@optimus-web/icons';

interface AssociateOwnerCheckboxProps {
    ownerName: string;
    checked: boolean;
    disabled: boolean;
    onChange: () => void;
    name?: string;
}

export const AssociateOwnerCheckbox = ({
    name,
    ownerName,
    onChange,
    checked,
    disabled,
}: AssociateOwnerCheckboxProps) => (
    <Stack vertical>
        <Stack itemAlignment="center">
            <Body size="small">
                <LocalizedText textKey={TextKey.AssociateBillOwnerCheckboxHeading} />
            </Body>
            {UnicodeEntity.NoBreakSpace}
            <TooltippedIcon
                size="small"
                value={IconName.Info}
                tooltip={
                    disabled
                        ? TextKey.AssociateBillOwnerCheckboxTooltipDisabled
                        : TextKey.AssociateBillOwnerCheckboxTooltip
                }
            />
        </Stack>
        <Checkbox
            data-test-id={DataTestId.BillingAssociateCurrentOwnerCheckbox}
            onChange={onChange}
            checked={checked}
            disabled={disabled}
            name={name}
        >
            <LocalizedText textKey={TextKey.AssociateBillOwnerCheckboxLabel} substitutes={{ ownerName }} />
        </Checkbox>
    </Stack>
);
